


































import { Prop, Component, Vue } from 'vue-property-decorator';
import { Button } from 'element-ui';

import { shipmentService } from '@/services/ShipmentService';
import {
  fetchBill_bills,
  fetchShipment_shipments_billItems,
  fetchBill_bills_billItems
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    'el-button': Button
  }
})
export default class ShipmentList extends Vue {
  @Prop({ required: true, type: Array }) public shipments!: fetchBill_bills[];
  @Prop({ required: true, type: String }) public billId!: string;
}
